module.exports = __webpack_public_path__ + "img/followupmilk_p.ff955571.png";